import { render, staticRenderFns } from "./detalleNacionalAdd.vue?vue&type=template&id=44f0ff37"
import script from "./detalleNacionalAdd.vue?vue&type=script&lang=js"
export * from "./detalleNacionalAdd.vue?vue&type=script&lang=js"
import style0 from "./detalleNacionalAdd.vue?vue&type=style&index=0&id=44f0ff37&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports